module.exports = __webpack_public_path__ + "static/media/checkmark.51262748.svg";